import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceiptApiAdapter, RegisterSeparationTimeRequest } from '../adapters/ReceiptApiAdapter';

export const useSeparationTimes = (entryId: number, receiptId: number) => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const receiptAdapter = new ReceiptApiAdapter(httpClient);

  const registerSeparationTimeMutation = useMutation({
    mutationFn: (data: RegisterSeparationTimeRequest) =>
      receiptAdapter.registerSeparationTime(entryId, receiptId, data),
    onSuccess: () => {
      // Invalidar queries relacionadas para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ['entry-receipt', entryId, receiptId] });
      queryClient.invalidateQueries({ queryKey: ['entry-receipt-movements', entryId, receiptId] });
    },
  });

  const updateSeparationTimeMutation = useMutation({
    mutationFn: ({ separationTimeId, data }: { separationTimeId: number; data: RegisterSeparationTimeRequest }) =>
      receiptAdapter.updateSeparationTime(entryId, receiptId, separationTimeId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entry-receipt', entryId, receiptId] });
      queryClient.invalidateQueries({ queryKey: ['entry-receipt-movements', entryId, receiptId] });
    },
  });

  return {
    registerSeparationTime: registerSeparationTimeMutation.mutateAsync,
    isRegistering: registerSeparationTimeMutation.isPending,
    error: registerSeparationTimeMutation.error,
    updateSeparationTime: updateSeparationTimeMutation.mutateAsync,
    isUpdating: updateSeparationTimeMutation.isPending,
    updateError: updateSeparationTimeMutation.error,
  };
};
